import { Skeleton } from '@/components/ui/skeleton';
import { cn } from '@/lib/utils';
import { FC } from 'react';

type Props = {
    isMobile?: boolean;
};

const CurrentBalanceSkeleton: FC<Props> = ({ isMobile }) => {
    return (
        <div className={cn('flex-1 flex flex-col items-center bg-transparent')}>
            <Skeleton className={cn('h-3 w-16', isMobile && 'h-2.5 w-full')} />
            <Skeleton className={cn('h-3 w-25 ', isMobile && 'h-2.5 w-full')} />
        </div>
    );
};

export default CurrentBalanceSkeleton;
